// src/components/common/IconFolderPlusButton.tsx
// Botão-ícone de "criar" para o cabeçalho de página, na mesma posição e com o mesmo
// comportamento visual do IconSearchButton usado em Requisições/Usuários.
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderPlus } from '@/icons';
import './IconFolderPlusButton.css';

interface IconFolderPlusButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconFolderPlusButton: React.FC<IconFolderPlusButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-folder-plus-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faFolderPlus} />
    </button>
  );
};

export default IconFolderPlusButton;
